import { firstValueFrom } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ApiService, TransferableGetApiService, IPaginatedResponse } from '@cakeiteasy/web-utils';
import { TransferState } from '@angular/core';

import { IFilterCategory } from '../../cakes-overview/models/i-filter-category';

export class ICitySearch {
  placeName?: string;
  cityName: string;
  postNumber: string;
  countryCode: string;
}

@Injectable()
export class CitiesApiService extends TransferableGetApiService {

  constructor(@Inject('AppConfig') appConfig: any,
              @Inject(PLATFORM_ID) _platformId: any,
              transferState: TransferState,
              api: ApiService) {
    super(api, appConfig, _platformId, transferState);
  }

  /**
   * Returns found location
   * @param countryCode
   * @param postNumber
   */
  public searchLocationByPostNumber(countryCode: string, postNumber: string): Promise<ICitySearch | null> {
    return firstValueFrom(this.api
      .get('api.city', 'city_by_post_number', { countryCode, postNumber }))
      .catch((err) => null);
  }

  public getCityBakeriesWithDeliveryOn(countryCode: string, postNumber: string): Promise<string | null> {
    return firstValueFrom(this.api
      .get('api.city', 'city_by_post_number', { countryCode, postNumber }))
      .then((res) => res.cityName)
      .catch((err) => null);
  }

  public getCities(countryCode: string, mostPopular: boolean = null): Promise<any[]> {
    return firstValueFrom(this.getWithCaching('api.city', 'cities', {}, { params: { countryCode, mostPopular } }))
      .then((res) => {
        return res;
      })
      .catch((err) => null);
  }

  public getCityByRefName(refName: string, countryCode: string): Promise<any> {
    return firstValueFrom(this.getWithCaching('api.city', 'city_by_name', { refName }, {
      params: {
        country: countryCode
      }
    }));
  }
}
